import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    Wrap: {
        position: 'relative',
    },
    Label:{
        position: 'absolute',
        left: '16px',
        top: '16px',
        color: 'rgba(0, 0, 0, 0.54)',
        padding: '0',
        fontSize: '0.8rem',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontWeight: '400',
        lineHeight: '1',
        letterSpacing: '0.00938em',
    },
    TextInput: {
        background: '#e8e8e8',
        height: 'auto',
        overflow: 'hidden',
        minHeight: '1.1876em',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        padding: '27px 12px 10px',
        width: '94%',
        margin: '5px',
        outline:'none',
        border: '0',
        borderBottom: '1px solid #000',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
    },
});

export default function MyUrlPublic ({ record }) {
    const classes = useStyles();
    let mod_url = '';
    
    if(record.Bucket === "wibbes-bucket"){
        mod_url = 'https://d2f3dcmxfmur0h.cloudfront.net/'+record.key;
    } else if(record.url) {
        let url = record.url;
        let modife_url = url.replace('https://d2f3dcmxfmur0h.cloudfront.net/','https://d2f3dcmxfmur0h.cloudfront.net/');
        mod_url = modife_url.replace('m3u8','mp4');
    } else if(record.preview_img_url) {
        // Utiliser preview_img_url s'il existe
        mod_url = record.preview_img_url.replace('.png', '.mp4').replace('-preview', '');
    } else if(record.original_preview_url) {
        // Utiliser original_preview_url en dernier recours
        mod_url = record.original_preview_url.replace('.png', '.mp4').replace('-original-preview', '');
    }
    
    return(
        <div className={classes.Wrap}>
            <label className={classes.Label}>Public URL</label>
            <input className={classes.TextInput} value={mod_url} readOnly></input>
        </div>
    );
}